import axios from "axios";

export const resetPass = (data) => {
  return axios.post(`api/open/resetPass`, data);
};
